import { render, staticRenderFns } from "./Sticker.vue?vue&type=template&id=c1396adc&scoped=true&"
import script from "./Sticker.vue?vue&type=script&lang=js&"
export * from "./Sticker.vue?vue&type=script&lang=js&"
import style0 from "./Sticker.vue?vue&type=style&index=0&id=c1396adc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1396adc",
  null
  
)

export default component.exports